import { Model, Collection } from '@/models/BaseModel';

import {
    equal,
    integer,
    min,
    string,
    boolean
} from 'vue-mc/validation';

export enum ProductSize {
    Regular = 1,
    Medium = 2,
    Large = 3
}

export class Product extends Model {
    public options() {
        return {
            identifier: 'id'
        };
    }

    public defaults() {
        return {
            id: null,
            category_id: null,
            name: '',
            category_name: '',
            price_regular: null,
            price_medium: null,
            price_large: null,
            cost_regular: null,
            cost_medium: null,
            cost_large: null,
            available: true,
            containsDairy: false,
            containsEgg: false,
            containsSeafood: false,
            containsTreeNuts: false,
            containsSoy: false,
            containsGluten: false,
            containsPeanuts: false,
        };
    }

    public mutations() {
        return {
            id: (id: any) => Number(id) || null,
            category_id: Number,
            name: String,
            category_name: String,
            description: String,
            price_regular: Number,
            price_medium: Number,
            price_large: Number,
            cost_regular: Number,
            cost_medium: Number,
            cost_large: Number,
            available: Boolean,
            containsDairy: Boolean,
            containsEgg: Boolean,
            containsSeafood: Boolean,
            containsTreeNuts: Boolean,
            containsSoy: Boolean,
            containsGluten: Boolean,
            containsPeanuts: Boolean
        };
    }

    public validation() {
        return {
            id: integer.and(min(1)).or(equal(null)),
            category_id: integer,
            name: string,
            category_name: string,
            description: string,
            available: boolean
            // price_regular: min(0).or(equal(null)),
            // price_medium: min(0).or(equal(null)),
            // price_large: min(0).or(equal(null)),
        };
    }

    public routes() {
        return {
            fetch: "products/{id}",
            save: "products",
            delete: "products/{id}"
        };
    }
}

export class ProductCollection extends Collection {
    public model() {
        return Product;
    }

    public defaults() {
        return {
            orderBy: 'name',
        };
    }

    public routes() {
        return {
            fetch: "products",
        };
    }

    public fetchData() {
        return this.fetch();
    }
}
